var _path, _path2;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgPinV2 = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33333 10.6666L2 14",
    stroke: "#59697D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.80433 7.47149L8.51986 13.187C8.94101 13.6082 9.66098 13.3078 9.65792 12.7122L9.64399 10.0047C9.64288 9.78731 9.74781 9.58304 9.92516 9.45735L13.6885 6.79017C14.0254 6.55139 14.0664 6.06686 13.7744 5.77486L10.2227 2.22322C9.93143 1.93192 9.44829 1.97191 9.20884 2.30714L6.53234 6.05424C6.4072 6.22944 6.20515 6.33342 5.98985 6.33342H3.27574C2.6818 6.33342 2.38435 7.05151 2.80433 7.47149Z",
    stroke: "#59697D"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPinV2, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/pin-v2.a5da6d0c.svg";
export { ForwardRef as ReactComponent };